// @ts-check
(() => {
  // 予約商品判定関数
  const isPreorderProduct = (productTitle) => {
    return (
      productTitle &&
      (productTitle.includes("予約") || productTitle.includes("Pre-order"))
    );
  };

  // カート混在チェック関数
  const checkCartMixing = async (newProductTitle) => {
    try {
      const response = await fetch("/cart.js", {
        credentials: "same-origin",
        method: "GET",
      });
      const cart = await response.json();

      const isNewProductPreorder = isPreorderProduct(newProductTitle);

      // カートが空の場合はOK
      if (!cart.items || cart.items.length === 0) {
        return true;
      }

      // カート内に予約商品があるかチェック
      const hasPreorderInCart = cart.items.some((item) =>
        isPreorderProduct(item.product_title)
      );

      // 混在チェック
      if (isNewProductPreorder && !hasPreorderInCart) {
        alert(
          "予約商品と通常商品は同時にカートに入れることができません。\n通常商品を購入後、予約商品をカートに追加してください。"
        );
        return false;
      } else if (!isNewProductPreorder && hasPreorderInCart) {
        alert(
          "通常商品と予約商品は同時にカートに入れることができません。\n予約商品を購入後、通常商品をカートに追加してください。"
        );
        return false;
      }

      return true;
    } catch (error) {
      console.error("カートチェックエラー:", error);
      return true; // エラーの場合は追加を許可
    }
  };

  document.addEventListener("variant:change", (event) => {
    try {
      const currentVariant = event.detail.variant;
      const variants = window.pippilotta.product.variants;
      const currentVariantMetafields = variants.find(
        (variant) => variant.id === currentVariant.id
      );

      if (!currentVariantMetafields) return;

      const $restockScheduleWrapper = document.getElementById(
        "restock_schedule_wrapper"
      );
      const $restockSchedule = document.getElementById("restock_schedule");
      if (!$restockScheduleWrapper) {
        console.error("No restock schedule element");
        return;
      }
      if (currentVariant.available) {
        $restockScheduleWrapper.classList.add("hide");
      } else if (!currentVariantMetafields?.restock_schedule) {
        $restockScheduleWrapper.classList.remove("hide");
        $restockSchedule?.classList.add("hide"); // お気に入り追加促進文言のみ表示
      } else {
        $restockScheduleWrapper.classList.remove("hide");
        $restockSchedule?.classList.remove("hide");
        const $text = $restockScheduleWrapper.querySelector("[data-text]");
        if ($text) {
          $text.textContent =
            currentVariantMetafields.restock_schedule || "未定";
        }
      }
    } catch (error) {
      console.error(error);
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    // すべてのカートフォームを無効化して、カスタムハンドラーに置き換え
    document.querySelectorAll("form[action='/cart/add']").forEach(($form) => {
      // actionを無効化
      $form.action = "javascript:void(0);";

      // カスタムハンドラーを追加
      $form.addEventListener("submit", async (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        // 商品タイトルを取得
        let productTitle = "";

        const variantJsonElement = document.querySelector(
          "[data-variant-json]"
        );
        if (variantJsonElement) {
          try {
            const variants = JSON.parse(variantJsonElement.textContent || "[]");
            if (variants.length > 0 && variants[0].name) {
              productTitle = variants[0].name.split(" - ")[0];
            }
          } catch (e) {
            console.error("バリアントJSON解析エラー:", e);
          }
        }

        if (!productTitle) {
          const productTitleElement = document.querySelector(
            ".product__title, h1.product-single__title, [data-product-title]"
          );
          productTitle = productTitleElement
            ? productTitleElement.textContent.trim()
            : "";
        }

        // カート混在チェック
        const canAdd = await checkCartMixing(productTitle);

        if (!canAdd) {
          // ローディング状態を解除
          const submitButton = $form.querySelector("[data-add-to-cart]");
          if (submitButton) {
            submitButton.classList.remove("btn--loading");
          }

          return false;
        }

        // フォームデータを手動で送信 (theme.jsの方法を模倣)
        const submitButton = $form.querySelector("[data-add-to-cart]");

        if (submitButton) {
          submitButton.classList.add("btn--loading");
        }

        // theme.jsと同じようにフォームデータをシリアライズ
        const formData = new FormData($form);
        const data = new URLSearchParams();
        for (const [key, value] of formData.entries()) {
          data.append(key, value);
        }

        try {
          const response = await fetch("/cart/add", {
            method: "POST",
            body: data,
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          // レスポンスがJSONかどうかチェック
          const contentType = response.headers.get("content-type");
          let result;

          if (contentType && contentType.includes("application/json")) {
            result = await response.json();
          } else {
            // HTMLが返された場合は成功として扱う（通常のフォーム送信のように）
            if (response.ok) {
              // カートページにリダイレクト
              window.location.href = "/cart";
              return;
            } else {
              throw new Error(
                `HTTP ${response.status}: ${response.statusText}`
              );
            }
          }

          if (response.ok && result) {
            // 成功時の処理 (theme.jsの処理を模倣)
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: { product: result },
              })
            );

            // LINE Tag
            try {
              _lt("send", "cv", { type: "AddToCart" }, [
                "a868bf9b-d27a-45f1-a39e-5c04aeb7e161",
              ]);
            } catch (error) {
              console.error("LINE Tag error:", error);
            }

            // カートページにいる場合はリロード
            if (document.body.classList.contains("template-cart")) {
              window.scrollTo(0, 0);
              location.reload();
            }
          } else {
            console.error("カート追加エラー:", result);
          }
        } catch (error) {
          console.error("カート追加リクエストエラー:", error);
        } finally {
          if (submitButton) {
            submitButton.classList.remove("btn--loading");
          }
        }

        return false;
      });
    });

    // 元のLINE Tagトラッキングコードを追加
    document.querySelectorAll("[data-add-to-cart]").forEach(($button) => {
      $button.addEventListener("click", () => {
        try {
          // LINE Tag
          _lt(
            "send",
            "cv",
            {
              type: "AddToCart",
            },
            ["a868bf9b-d27a-45f1-a39e-5c04aeb7e161"]
          );
          // End LINE Tag
        } catch (error) {
          console.error(error);
        }
      });
    });
  });
})();
